module.exports = __webpack_public_path__ + "img/feature_buy_zh.7bec9544.png";